<template>
  <div>
    <div class="px-8">
      <div>
        <v-btn
          @click="changeDisplayOption"
          icon
          outlined
          class="float-left mr-3"
          ><v-icon>{{
            displayOption === "PlanCard2"
              ? "mdi-view-list"
              : "mdi-view-grid-outline"
          }}</v-icon></v-btn
        >

        <v-btn
          v-for="(_tab, i) in tabs"
          rounded
          class="mr-3 text-capitalize float-left"
          :key="i"
          :outlined="_tab.value != tab"
          :color="_tab.value == tab ? '#0088FF' : '#42424290'"
          :dark="_tab.value == tab"
          @click="tab = _tab.value"
          >{{ _tab.title }}</v-btn
        >

        <v-btn
          @click="openSimulador"
          rounded
          dark
          color="#0088FF"
          class="text-capitalize float-right"
          >novo plano <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>

      <!-- tab dos planos com solucao -->
      <div v-if="tab == 0" class="pt-5">
        <div class="pa-3"></div>
        <div class="card py-2 px-4" v-if="plans.length === 0">
          <p class="text-overline">Nenhum plano encontrado</p>
          <p class="text-body-2">
            Novos planos são criados ao gerar um alocação no
            simulador.
          </p>
        </div>

        <div
          :class="
            `tab py-8 ${
              displayOption === 'PlanCard2' ? 'option1' : 'option2'
            }`
          "
        >
          <!-- <PlanCard2 Loading class="float-left" :waiting="1" /> -->

          <div v-for="(plan, index) in itens_tab1" :key="index">
            <component
              :is="displayOption"
              :title="plan.name"
              :date="handleFormatDayAndTime(plan.date)"
              @delete="() => handleDelete(plan)"
              @open="() => handleopen(plan)"
              @update:title1="e => handleRename(plan, e)"
              class="float-left"
              :Loading="plan.queue"
            >
              <div class="w-100">
                <p class="text-start float-left">
                  <span class="mr-3"
                    ><v-icon color="#424242"
                      >mdi-human-male-board</v-icon
                    >
                    {{ plan.numberClasses }}</span
                  >
                  <span
                    ><v-icon color="#424242">mdi-door-closed</v-icon>
                    {{ plan.numberRooms }}</span
                  >
                </p>
                <p
                  v-if="plan.share != 0"
                  class="float-right px-4 text-caption font-weight-bold color-blue"
                >
                  <v-icon color="#0088FF" size="small" class="mr-2"
                    >mdi-share-variant</v-icon
                  >compartilhado
                </p>
              </div>
            </component>
          </div>
        </div>
        <v-pagination
          light
          class="pagination py-5"
          v-model="page_tab1"
          :length="page_tab1_amount"
          :total-visible="5"
        ></v-pagination>
      </div>

      <!-- tab dos planos sem solucao salvos no navegador -->
      <div v-if="tab == 1">
        <div class="pa-3"></div>
        <div class="card py-2 px-4" v-if="kept.length === 0">
          <p class="text-overline">Nenhum dado encontrado</p>
          <p class="text-body-2">
            É possível salvar os dados adicionados no simulador. Essa
            configuração salva aparecerá aqui.
          </p>
        </div>

        <div
          :class="
            `tab py-8 ${
              displayOption === 'PlanCard2' ? 'option1' : 'option2'
            }`
          "
        >
          <div v-for="(plan, index) in itens_tab2" :key="index">
            <component
              saved
              :is="displayOption"
              :title="plan.input.name"
              :date="handleFormatDayAndTime(plan.date)"
              :description="
                `Continue de onde parou. ${plan.input.rooms.length} salas e ${plan.input.classes.length} turmas.`
              "
              @duplicar="() => handleDuplicar(plan)"
              @open="() => handleClickSaved(plan)"
              @delete="() => deleteSaved(plan)"
              class="float-left"
            />
          </div>
        </div>
        <v-pagination
          light
          class="pagination py-5"
          v-model="page_tab2"
          :length="page_tab2_amount"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PlanCard2 from "@/components/PlanCard2.vue";
import PlanCardList from "@/components/PlanCardList.vue";
import { updatePlan, deletePlan } from "@/api/paas/plans";
import { formatDayAndTime } from "@/utils/Format";

export default {
  name: "HandleDisplayPlans",
  props: {
    plans: Array,
    kept: Array
  },
  components: {
    PlanCard2,
    PlanCardList
  },
  data() {
    return {
      tab: 0,
      page_amount: 10,
      page_tab1: 1,
      page_tab2: 1
    };
  },
  computed: {
    tabs() {
      return [
        {
          value: 0,
          title: "Planos simulados"
        },
        {
          value: 1,
          title: "Planos não simulados"
        }
      ];
    },
    displayOption() {
      if (this.$vuetify.breakpoint.width < 850) {
        return "PlanCard2";
      }
      return this.$store.getters.getDisplayPlanOption;
    },
    page_tab1_amount() {
      return Math.ceil(this.plans.length / this.page_amount);
    },
    page_tab2_amount() {
      return Math.ceil(this.kept.length / this.page_amount);
    },
    itens_tab1() {
      return this.sliceList(this.plans, this.page_tab1);
    },
    itens_tab2() {
      return this.sliceList(this.kept, this.page_tab2);
    }
  },
  methods: {
    changeDisplayOption() {
      this.$store.dispatch("changeDisplayPlan");
    },
    sliceList(list, page) {
      const start = (page - 1) * this.page_amount;
      const end = start + this.page_amount;
      return list.slice(start, end);
    },
    handleopen(_plan) {
      this.$router.push({ path: `/paas/planos/${_plan.id}` });
    },
    handleRename(_plan, _new_title) {
      let keep_old = _plan.name;
      _plan.name = _new_title;
      updatePlan(_plan).catch(_ => {
        console.log(_);
        _plan.name = keep_old;
      });
    },
    openSimulador() {
      this.$router.push({ path: "/paas-simulador" });
    },
    handleFormatDayAndTime(_date) {
      return formatDayAndTime(_date);
    },
    handleDelete(_plan) {
      let idx = this.plans.findIndex(_ => _.id === _plan.id);
      this.plans.splice(idx, 1);
      deletePlan(_plan).catch(_ => {
        console.log(_);
        this.plans.splice(idx, 0, _plan);
      });
    },
    handleClickSaved(item) {
      let copyInput = JSON.parse(JSON.stringify(item.input));

      this.$store.dispatch("setPaasInputPlaceholder", {
        id: item.id,
        ...copyInput
      });

      this.$router.push({ path: "/paas-simulador" });
    },
    handleDuplicar(item) {
      let copyInput = JSON.parse(JSON.stringify(item.input));

      this.$store.dispatch("updateEditSave", copyInput);

      alert(
        "Duplicado!\nPara renomear, basta clicar no novo card e fazer as alterações na página da simulação que irá abrir. Não esqueça de salvar depois!"
      );
    },
    deleteSaved(item) {
      let idx = this.kept.findIndex(_ => _.id == item.id);
      this.$store.dispatch("removeEditSaveByIdx", { idx: idx });
      this.$emit("update:kept");
      this.EditList = this.$store.getters.getEditSaveList;
    }
  }
};
</script>

<style scoped>
.tab {
  clear: both;
  display: grid;
  width: 100%;
}

.option1 {
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px; /* Espaçamento entre os cards */
}

.option2 {
  grid-template-columns: repeat(auto-fill, minmax(800px, 1fr));
  gap: 4px; /* Espaçamento entre os cards */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.card {
  display: table;
  width: 100%;
  margin-top: 50px;
  border-radius: 4px;
  border: 1px solid #42424230;
  grid-column: 1 / -1;
}

.pagination {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.color-blue {
  color: #0088ff;
}

.color-blue:hover {
  color: #FFF;
}
</style>
